import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { getLastMachineTimestamp, getLastSelectedMachineSensorTimestamp } from '../../redux/machines/selectors';
import { getUserData } from '../../redux/user/selectors';

const LAST_TIMESTAMP_TYPES = {
  dashboard: getLastMachineTimestamp,
  machine: getLastSelectedMachineSensorTimestamp
};

interface LastUpdatedProps {
  type: 'dashboard' | 'machine';
  align?: 'right' | 'left' | 'center' | 'inherit' | 'justify';
  marginBottom?: string;
}

const LastUpdated = ({ type, align, marginBottom = '1.5rem' }: LastUpdatedProps) => {
  const { t } = useTranslation();
  const lastTimestamp = useSelector(LAST_TIMESTAMP_TYPES[type]);
  const user = useSelector(getUserData);

  const dateToBeShown = moment(lastTimestamp || null).locale(user.language || 'en_US');

  return (
    <Typography
      variant="subtitle2"
      color="textSecondary"
      data-testid="last-updated"
      align={align || 'left'}
      style={{ marginBottom }}
    >
      {t('dashboard.machines.last_updated')} {dateToBeShown.isValid() ? dateToBeShown.format('LLL') : '---'}
    </Typography>
  );
};

export default React.memo(LastUpdated);
